import React from 'react';
import styles from './EpisodeLoadingState.module.css';

const EpisodeLoadingState = ({ episode }) => {
  const getStatusInfo = () => {
    // Check if audio files exist and are not pending
    if (episode.audio_files && episode.audio_files.length > 0) {
      // Check if any audio file is still pending
      const hasPendingAudio = episode.audio_files.some(audio => audio.status === 'pending');
      
      if (hasPendingAudio) {
        return {
          status: 'audio_generating',
          message: 'Podcast is being recorded... Check back in a few minutes',
          showSpinner: true
        };
      }
      
      // Audio files exist and are not pending, episode is complete
      return {
        status: 'complete',
        message: 'Episode ready to play',
        showSpinner: false
      };
    }

    // Check script status
    if (episode.script) {
      // If script is pending, show script generation message
      if (episode.script.status === 'pending') {
        return {
          status: 'script_generating',
          message: 'Creating script... Check back in a few minutes',
          showSpinner: true
        };
      }

      // If script is complete but no audio files yet, show audio generation message
      if (episode.script.status === 'completed' && (!episode.audio_files || episode.audio_files.length === 0)) {
        return {
          status: 'audio_generating',
          message: 'Podcast is being recorded... Check back in a few minutes',
          showSpinner: true
        };
      }

      // If script failed
      if (episode.script.status === 'failed') {
        return {
          status: 'script_failed',
          message: 'Script generation failed',
          showSpinner: false
        };
      }
    }

    // Default: episode exists but no script data yet
    return {
      status: 'pending',
      message: 'Episode created, waiting for processing... Check back in a few minutes',
      showSpinner: true
    };
  };

  const statusInfo = getStatusInfo();

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingContent}>
        {statusInfo.showSpinner && (
          <div className={styles.spinner}></div>
        )}
        <div className={styles.statusMessage}>
          <h4>{episode.title}</h4>
          <p className={styles.message}>{statusInfo.message}</p>
          {statusInfo.progress !== undefined && (
            <div className={styles.progressBar}>
              <div 
                className={styles.progressFill} 
                style={{ width: `${statusInfo.progress}%` }}
              ></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EpisodeLoadingState;
